<template>
  <div class="bg-surface-default-low px-40 pb-40 pt-24">
    <nav class="mx-auto flex max-w-[1280px] flex-col gap-16">
      <NavCategoryHeader
        :see-all-url="universeURL"
        :tracking="{
          zone: 'mega menu',
          name: universeTitle,
          value: 'view_all',
        }"
        @click-see-all="$emit('click-item')"
      />
      <ul
        :aria-label="universeTitle"
        class="grid gap-32 md:grid-cols-3 lg:grid-cols-5"
      >
        <li v-for="item in items" :key="item.id" class="max-w-256">
          <RevLink
            class="body-2 flex flex-col gap-8"
            role="menuitem"
            :to="item.url"
            :tracking="{
              zone: 'mega menu',
              name: universeTitle,
              value: item.title,
            }"
            :underlined="false"
            @click="$emit('click-item')"
          >
            <RevIllustration
              v-if="item.image"
              :alt="item.title"
              class="rounded-lg"
              :height="960"
              :src="item.image"
              :width="1280"
            />
            <span class="text-action-default-hi body-1-bold">
              {{ item.title }}
            </span>
          </RevLink>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'

import type { NavigationItem } from '../../types'
import NavCategoryHeader from '../shared/NavCategoryHeader.vue'

defineProps<{
  universeTitle: string
  universeURL: string
  items: NavigationItem[]
}>()

defineEmits(['click-item'])
</script>
